import React from 'react';
import { InterpolationTuningControls } from '../InterpolationTuningControls';

/**
 * In-game live interpolation/feel tuning overlay (DebugHUDHost tool
 * `interpTuning`). Shares the game's JS context, so the sliders/presets here
 * actually re-tune the running remote-entity interpolators (and the mob-bump
 * feel) on the next frame — the real live-A/B surface DJ asked for.
 */
export const InterpTuningOverlayContent: React.FC = () => (
  <div style={{ padding: 8, overflow: 'auto', maxHeight: '100%' }}>
    <InterpolationTuningControls />
  </div>
);
